import {
  AmsDataGridCellRenderParams,
  AmsDataGridColumnDef
} from "../framework/component/data-grid/AmsDataGrid";
import {ProjectListing} from "./model/ProjectListing";
import {Link} from "react-router-dom";
import {getSummaryStatusLabel} from "./model/ApplicationStatus";
import {getTypeLabel} from "./model/ApplicationType";
import React from "react";

const headerClassName = 'grid-header';

export const projectListColumns: AmsDataGridColumnDef[] = [
  {
    field: 'applicationId',
    headerName: 'ID',
    type: 'number',
    width: 90,
    filterable: false,
    headerClassName: headerClassName,
    renderCell: (params: AmsDataGridCellRenderParams) => <Link to={`/projects/${params.row.applicationId}`}>{params.row.applicationId}</Link>
  },
  {
    field: 'title',
    headerName: 'Title',
    type: 'string',
    width: 350,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'piName',
    headerName: 'PI Name',
    flex: .15,
    filterable: false,
    headerClassName: headerClassName,
    renderCell: (params: AmsDataGridCellRenderParams) => {
      if (params.row.currentPi) {
        return <div>{params.row.piName}</div>;
      } else {
        return <div className={"text-danger fw-bold"}>{params.row.piName}</div>
      }
    }
  },
  {
    field: 'instituteName',
    headerName: 'Institute',
    type: 'string',
    flex: .25,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'applicationStatus',
    headerName: 'Status',
    type: 'string',
    flex: .15,
    filterable: false,
    valueGetter: (value: string, row:ProjectListing) => getSummaryStatusLabel(value, row.projectStatus),
    headerClassName: headerClassName,
  },
  {
    field: 'applicationType',
    headerName: 'Type',
    type: 'string',
    flex: .20,
    filterable: false,
    valueGetter: (value: string) => getTypeLabel(value),
    headerClassName: headerClassName,
  },
  {
    field: 'countryName',
    headerName: 'Country',
    type: 'string',
    flex: .20,
    filterable: false,
    headerClassName: headerClassName,
  },
];


